import { Injectable } from '@angular/core';
import { LocalStorageService } from '@app/core/services/web-storage.service';
import { Language, Languages } from '@app/core/models';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  languages = Languages;

  constructor(private localStorage: LocalStorageService) { }

  saveSelectedLanguage(language: Language): void {
    this.localStorage.set('language', language.code);
  }

  getSelectedLanguage(): Language {
    const languageCode = this.localStorage.get('language');
    return languageCode ? this.getLanguageByCode(languageCode) : null;
  }

  getLanguage(key: string): Language {
    return this.languages[key];
  }

  getLanguageByCode(code: string): Language {
    for (const lang of Object.keys(Languages)) {
      if (Languages[lang].code === code) {
        return Languages[lang];
      }
    }
    return null;
  }
}
